import React from 'react';
import './Header.scss';
import logo from '../../assets/img/WEB-BLANCO.png';
import bookingBtn from "../../assets/img/booking-btn.png"
import { NavLink } from 'react-router-dom';

const Header = () => {
  return (
    <div className='header__block'>
      <NavLink className="booking-home" to="/">
        <img className='header__logo' src={logo} alt="logo-flow-mune" />
      </NavLink>
      <NavLink className="booking-btn" to="/booking">
        <img className="booking__img" src={bookingBtn} alt="" />
        <p className='booking__label'>Contacto</p>
      </NavLink>
    </div>
  )
}

export default Header